import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex justify-space-between" }
const _hoisted_2 = { class: "text-decoration-none" }
const _hoisted_3 = { class: "mainInputs" }
const _hoisted_4 = { class: "mainInputs" }
const _hoisted_5 = { class: "d-flex justify-space-between align-center mb-2" }
const _hoisted_6 = { class: "d-flex justify-space-between align-center mb-2" }
const _hoisted_7 = { class: "d-flex justify-space-between align-center mb-2" }
const _hoisted_8 = { class: "d-flex justify-space-between align-center mb-2" }
const _hoisted_9 = { class: "d-flex justify-space-between align-center mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_custom_img_component = _resolveComponent("custom-img-component")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "8" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _cache[23] || (_cache[23] = _createElementVNode("h1", { class: "titleSt" }, "Componente Detalhamento Veículo", -1)),
              _createElementVNode("a", _hoisted_2, [
                _createVNode(_component_v_btn, {
                  class: "text-white",
                  color: "grey",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close-modal')))
                }, {
                  default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                    _createTextVNode("Cancelar", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  class: "text-white",
                  color: "#ff5000",
                  onClick: _ctx.store,
                  disabled: _ctx.btn_disabled
                }, {
                  default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                    _createTextVNode("Salvar", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick", "disabled"])
              ])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.fragmentId,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.fragmentId) = $event)),
                label: "ID do componente",
                "hide-details": "auto",
                onKeyup: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onInputChange()))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.title,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.title) = $event)),
                label: "Título",
                rules: _ctx.rules,
                "hide-details": "auto",
                onKeyup: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onInputChange()))
              }, null, 8, ["modelValue", "rules"])
            ]),
            _createElementVNode("div", null, [
              _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1)),
              _cache[29] || (_cache[29] = _createElementVNode("hr", null, null, -1)),
              _cache[30] || (_cache[30] = _createElementVNode("h2", null, "Classificação", -1)),
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classifications, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id,
                    class: "mainInputs"
                  }, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("h3", null, "Classificação " + _toDisplayString(item.id), 1),
                      (item.id != 1)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            color: "red",
                            size: "small",
                            onClick: ($event: any) => (_ctx.removeClassificationItem(item.id))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                                  _createTextVNode("mdi-delete", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[25] || (_cache[25] = _createTextVNode(" Remover ", -1))
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_v_text_field, {
                      modelValue: item.fragmentClassificationId,
                      "onUpdate:modelValue": ($event: any) => ((item.fragmentClassificationId) = $event),
                      label: "ID da classificação",
                      "hide-details": "auto",
                      onKeyup: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onInputChange()))
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                    _createVNode(_component_v_text_field, {
                      modelValue: item.classification,
                      "onUpdate:modelValue": ($event: any) => ((item.classification) = $event),
                      label: "Classificação",
                      rules: _ctx.classificationRules,
                      "hide-details": "auto",
                      onKeyup: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onInputChange()))
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"]),
                    _createVNode(_component_v_switch, {
                      modelValue: item.required,
                      "onUpdate:modelValue": ($event: any) => ((item.required) = $event),
                      color: _ctx.movida_color,
                      onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onInputChange())),
                      label: 'Preenchimento obrigatório? ' + (item.required ? 'Sim' : 'Não')
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "color", "label"])
                  ]))
                }), 128)),
                _createVNode(_component_v_btn, {
                  onClick: _ctx.addClassificationItem,
                  color: "primary",
                  class: "mt-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                        _createTextVNode("mdi-plus", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[27] || (_cache[27] = _createTextVNode(" Adicionar classificação ", -1))
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[35] || (_cache[35] = _createElementVNode("br", null, null, -1)),
              _cache[36] || (_cache[36] = _createElementVNode("hr", null, null, -1)),
              _cache[37] || (_cache[37] = _createElementVNode("h2", null, "Combustível", -1)),
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fuelTypes, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id,
                    class: "mainInputs"
                  }, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("h3", null, "Combustível " + _toDisplayString(item.id), 1),
                      (item.id != 1)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            color: "red",
                            size: "small",
                            onClick: ($event: any) => (_ctx.removeFuelTypeItem(item.id))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                                  _createTextVNode("mdi-delete", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[32] || (_cache[32] = _createTextVNode(" Remover ", -1))
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_v_text_field, {
                      modelValue: item.fragmentFuelTypeId,
                      "onUpdate:modelValue": ($event: any) => ((item.fragmentFuelTypeId) = $event),
                      label: "ID do combustível",
                      "hide-details": "auto",
                      onKeyup: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onInputChange()))
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                    _createVNode(_component_v_text_field, {
                      modelValue: item.fuelType,
                      "onUpdate:modelValue": ($event: any) => ((item.fuelType) = $event),
                      label: "Tipo de Combustível",
                      rules: _ctx.rules,
                      "hide-details": "auto",
                      onKeyup: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onInputChange()))
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"]),
                    _createVNode(_component_v_switch, {
                      modelValue: item.required,
                      "onUpdate:modelValue": ($event: any) => ((item.required) = $event),
                      color: _ctx.movida_color,
                      onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onInputChange())),
                      label: 'Preenchimento obrigatório? ' + (item.required ? 'Sim' : 'Não')
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "color", "label"])
                  ]))
                }), 128)),
                _createVNode(_component_v_btn, {
                  onClick: _ctx.addFuelTypeItem,
                  color: "primary",
                  class: "mt-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                        _createTextVNode("mdi-plus", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[34] || (_cache[34] = _createTextVNode(" Adicionar combustível ", -1))
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[42] || (_cache[42] = _createElementVNode("br", null, null, -1)),
              _cache[43] || (_cache[43] = _createElementVNode("hr", null, null, -1)),
              _cache[44] || (_cache[44] = _createElementVNode("h2", null, "Transmissão", -1)),
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transmissions, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id,
                    class: "mainInputs"
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("h3", null, "Transmissão " + _toDisplayString(item.id), 1),
                      (item.id != 1)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            color: "red",
                            size: "small",
                            onClick: ($event: any) => (_ctx.removeTransmissionItem(item.id))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                                  _createTextVNode("mdi-delete", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[39] || (_cache[39] = _createTextVNode(" Remover ", -1))
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_v_text_field, {
                      modelValue: item.fragmentTransmissionId,
                      "onUpdate:modelValue": ($event: any) => ((item.fragmentTransmissionId) = $event),
                      label: "ID da transmissão",
                      "hide-details": "auto",
                      onKeyup: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onInputChange()))
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                    _createVNode(_component_v_text_field, {
                      modelValue: item.transmission,
                      "onUpdate:modelValue": ($event: any) => ((item.transmission) = $event),
                      label: "Tipo de Transmissão",
                      rules: _ctx.rules,
                      "hide-details": "auto",
                      onKeyup: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onInputChange()))
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"]),
                    _createVNode(_component_v_switch, {
                      modelValue: item.required,
                      "onUpdate:modelValue": ($event: any) => ((item.required) = $event),
                      color: _ctx.movida_color,
                      onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onInputChange())),
                      label: 'Preenchimento obrigatório? ' + (item.required ? 'Sim' : 'Não')
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "color", "label"])
                  ]))
                }), 128)),
                _createVNode(_component_v_btn, {
                  onClick: _ctx.addTransmissionItem,
                  color: "primary",
                  class: "mt-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                        _createTextVNode("mdi-plus", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[41] || (_cache[41] = _createTextVNode(" Adicionar transmissão ", -1))
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[49] || (_cache[49] = _createElementVNode("br", null, null, -1)),
              _cache[50] || (_cache[50] = _createElementVNode("hr", null, null, -1)),
              _cache[51] || (_cache[51] = _createElementVNode("h2", null, "Text Input", -1)),
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.textInputs, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id,
                    class: "mainInputs"
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("h3", null, "Text Input " + _toDisplayString(item.id), 1),
                      (item.id != 1)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            color: "red",
                            size: "small",
                            onClick: ($event: any) => (_ctx.removeTextInputItem(item.id))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                                  _createTextVNode("mdi-delete", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[46] || (_cache[46] = _createTextVNode(" Remover ", -1))
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_v_text_field, {
                      modelValue: item.fragmentTextInputId,
                      "onUpdate:modelValue": ($event: any) => ((item.fragmentTextInputId) = $event),
                      label: "ID do text input",
                      "hide-details": "auto",
                      onKeyup: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onInputChange()))
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                    _createVNode(_component_v_text_field, {
                      modelValue: item.label,
                      "onUpdate:modelValue": ($event: any) => ((item.label) = $event),
                      label: "Label do campo",
                      rules: _ctx.rules,
                      "hide-details": "auto",
                      onKeyup: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onInputChange()))
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"]),
                    _createVNode(_component_v_switch, {
                      modelValue: item.required,
                      "onUpdate:modelValue": ($event: any) => ((item.required) = $event),
                      color: _ctx.movida_color,
                      onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.onInputChange())),
                      label: 'Preenchimento obrigatório? ' + (item.required ? 'Sim' : 'Não')
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "color", "label"])
                  ]))
                }), 128)),
                _createVNode(_component_v_btn, {
                  onClick: _ctx.addTextInputItem,
                  color: "primary",
                  class: "mt-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                        _createTextVNode("mdi-plus", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[48] || (_cache[48] = _createTextVNode(" Adicionar text input ", -1))
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[56] || (_cache[56] = _createElementVNode("br", null, null, -1)),
              _cache[57] || (_cache[57] = _createElementVNode("hr", null, null, -1)),
              _cache[58] || (_cache[58] = _createElementVNode("h2", null, "Text Area Input", -1)),
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.textAreaInputs, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id,
                    class: "mainInputs"
                  }, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("h3", null, "Text Area Input " + _toDisplayString(item.id), 1),
                      (item.id != 1)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            color: "red",
                            size: "small",
                            onClick: ($event: any) => (_ctx.removeTextAreaInputItem(item.id))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [...(_cache[52] || (_cache[52] = [
                                  _createTextVNode("mdi-delete", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[53] || (_cache[53] = _createTextVNode(" Remover ", -1))
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_v_text_field, {
                      modelValue: item.fragmentTextAreaInputId,
                      "onUpdate:modelValue": ($event: any) => ((item.fragmentTextAreaInputId) = $event),
                      label: "ID do text area input",
                      "hide-details": "auto",
                      onKeyup: _cache[17] || (_cache[17] = ($event: any) => (_ctx.onInputChange()))
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                    _createVNode(_component_v_text_field, {
                      modelValue: item.label,
                      "onUpdate:modelValue": ($event: any) => ((item.label) = $event),
                      label: "Label do campo",
                      rules: _ctx.rules,
                      "hide-details": "auto",
                      onKeyup: _cache[18] || (_cache[18] = ($event: any) => (_ctx.onInputChange()))
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"]),
                    _createVNode(_component_v_switch, {
                      modelValue: item.required,
                      "onUpdate:modelValue": ($event: any) => ((item.required) = $event),
                      color: _ctx.movida_color,
                      onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.onInputChange())),
                      label: 'Preenchimento obrigatório? ' + (item.required ? 'Sim' : 'Não')
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "color", "label"])
                  ]))
                }), 128)),
                _createVNode(_component_v_btn, {
                  onClick: _ctx.addTextAreaInputItem,
                  color: "primary",
                  class: "mt-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [...(_cache[54] || (_cache[54] = [
                        _createTextVNode("mdi-plus", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[55] || (_cache[55] = _createTextVNode(" Adicionar text area input ", -1))
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "4" }, {
          default: _withCtx(() => [
            _createVNode(_component_custom_img_component, { imageSrc: _ctx.imageSrc }, null, 8, ["imageSrc"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_snackbar, {
      modelValue: _ctx.snackbar,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.snackbar) = $event)),
      timeout: _ctx.timeout
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_v_btn, {
          variant: "text",
          onClick: _ctx.closeSnack
        }, {
          default: _withCtx(() => [...(_cache[60] || (_cache[60] = [
            _createTextVNode(" Fechar ", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_icon, { class: "ml-1" }, {
          default: _withCtx(() => [...(_cache[59] || (_cache[59] = [
            _createTextVNode(" mdi-information-outline ", -1)
          ]))]),
          _: 1
        }),
        _createTextVNode(" " + _toDisplayString(_ctx.text) + " ", 1)
      ]),
      _: 1
    }, 8, ["modelValue", "timeout"])
  ], 64))
}